export default "__VITE_ASSET__CDM4byZK__"